import { createApp } from 'vue';
import App from './App.vue';
import pinia from './store';
import router from './router';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import enUS from 'element-plus/es/locale/lang/en'
import ElementPlus from 'element-plus';
import '@/assets/styles/main.scss';
import './styles/reset.css';
import i18n from "./locale"
const app = createApp(App);
app.use(ElementPlus, {
    locale: zhCn
});

app.use(router);
app.use(pinia);
app.use(i18n)
// app.use(ElementPlus);
app.mount('#app');
